

import { EventData, fmtDate, statusColors } from "./types";

interface EventHeaderProps {
  event: EventData;
  isProjected: boolean;
}

export function EventHeader({ event, isProjected }: EventHeaderProps) {
  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-4 sm:p-5">
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap mb-1">
            <h2 className="text-lg sm:text-xl font-bold text-stone-900 font-serif truncate">{event.name}</h2>
            {isProjected && (
              <span className="text-xs px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 font-medium flex-shrink-0">
                Projected
              </span>
            )}
            <span className={`text-xs px-2 py-0.5 rounded-full font-medium flex-shrink-0 ${statusColors[event.status] ?? "bg-stone-100 text-stone-600"}`}>
              {event.status?.replace(/_/g, " ")}
            </span>
          </div>
          <p className="text-stone-500 text-sm">
            {event.client && <span className="font-medium text-stone-700">{event.client}</span>}
            {event.event_type && <span className="text-stone-400"> · {event.event_type}</span>}
          </p>
        </div>
        <div className="flex flex-wrap gap-3 sm:gap-4 text-sm">
          {event.start_date && (
            <div className="text-left sm:text-right">
              <div className="text-xs text-stone-400">Start Date</div>
              <div className="font-medium text-stone-700">{fmtDate(event.start_date)}</div>
            </div>
          )}
          {event.end_date && (
            <div className="text-left sm:text-right">
              <div className="text-xs text-stone-400">End Date</div>
              <div className="font-medium text-stone-700">{fmtDate(event.end_date)}</div>
            </div>
          )}
          {event.guest_count > 0 && (
            <div className="text-left sm:text-right">
              <div className="text-xs text-stone-400">Guests</div>
              <div className="font-medium text-stone-700">{event.guest_count}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
